<template>
  <pt-cps-payment-table v-loading="loading" class="pt-cps-payment-table__withData" :tabeLabels="tabeLabels" :tableData="tableData" :totalNumber="totalNumber"
  @getTableData="getTableData" ref="table" :isOutside="isOutside"></pt-cps-payment-table>
</template>

<script>
import PtCpsPaymentTable from './index'
export default {
  name: 'pt-cps-payment-table__withData',
  components: {
    'pt-cps-payment-table': PtCpsPaymentTable
  },
  props: {
    tabeLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      loading: false,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          // this.getTableData(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('cpsPaymentList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取cps缴费列表失败')
      })
    }
  }
}
</script>
